module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNCIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDQgMTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zLjU5MjQ4IDEuNDVWMTYuNDc1QzMuNTkyNDggMTYuODI1IDMuNDE3NDggMTcgMy4wNjc0OCAxN0gwLjk0MjQ4MUMwLjU5MjQ4MSAxNyAwLjQxNzQ4IDE2LjgyNSAwLjQxNzQ4IDE2LjQ3NVYxLjQ1QzAuNDE3NDggMS4xIDAuNTkyNDgxIDAuOTI1IDAuOTQyNDgxIDAuOTI1SDMuMDY3NDhDMy40MTc0OCAwLjkyNSAzLjU5MjQ4IDEuMSAzLjU5MjQ4IDEuNDVaIiBmaWxsPSIjQzZEMkRFIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/leagueoflegends/divisions/I.svg
// module id = df7p
// module chunks = 35